/*
 * Action Types
 */
export enum localLimitTypes {
  SET_LOCAL_STORAGE_LIMIT = '@localLimit/SET_LOCAL_STORAGE_LIMIT',
}

/*
 * State type
 */
export interface localLimitState {
  readonly localLimit: number;
}
